import type { ReactElement } from 'react';

import { ModelCustomVideosCard } from '../dashboard/ModelCustomVideosCard.js';
import { ModelFanClubTiersCard } from '../dashboard/ModelFanClubTiersCard.js';
import { ModelModePassAffiliateCard } from '../dashboard/ModelModePassAffiliateCard.js';
import { ModelWishlistCard } from '../dashboard/ModelWishlistCard.js';
import { SettingsStack } from './SettingsStack.js';

export function SettingsFansPage(): ReactElement {
  return (
    <SettingsStack titleKey="common.studio.settings.fansTitle" hintKey="common.studio.settings.fansHint">
      <ModelFanClubTiersCard />
      <ModelCustomVideosCard />
      <ModelModePassAffiliateCard />
      <ModelWishlistCard />
    </SettingsStack>
  );
}
